import styled from 'styled-components'

const CompanyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const Box = styled.div`
  padding: 20px 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
`

const DenyButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    width: 57px;
  }
`

export const s = { Box, CompanyWrapper, DenyButton }
